import styled from 'styled-components';
import { color, gap } from '@magalu/stereo-ui-styles';
import { grid, typography, space, compose } from 'styled-system';
import Box from '../Box';
export const Component = styled(Box)({
  display: 'grid'
}, compose(grid, typography, color, space, gap));